import { actionTypes, UserEntersLoyaltyCode } from "./Actions";

const userEntersLoyaltyCode: UserEntersLoyaltyCode = loyaltyCode => ({
  loyaltyCode,
  type: actionTypes.USER_ENTERS_LOYALTY_CODE
});

export default userEntersLoyaltyCode;
